module.exports = __webpack_public_path__ + "static/illustration1-1c29fa7e5ebf68283f943e16a96e9523.png";